import { Content, Button, H1 } from 'components/common'
import { React, Image, styled, mq } from 'x'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { customCards } from '../../components/custom.css';

const Container = styled.div`
  display:block;
  box-sizing: border-box;
  padding: 50px; 60px;

  @media (min-width: 2000px) {
    max-width:1366px;
    margin:0 auto;
  }

  ${mq.below('xl')} {
    padding: 30px; 60px;
  }
`

const Title = styled(H1)`
  max-width: 100%;
  color: #3e4d72;
  text-align:center;
  width: 100%;
  margin-bottom: 30px;
  font-size:42px;
  font-weight:800;
`

const CardsWrapper = styled.div`
  padding:30px;
`

const Card = styled.div`
  background-color: #3e4d72;
  border-top-left-radius:50px;
  border-bottom-right-radius:50px;

  a {
    display:block;
    border-top-left-radius:50px;
    border-bottom-right-radius:50px;
  }
`

const CardImgWrapper = styled.div `
  ${mq.above('xl')} {
    height:350px;
  }

  border-top-left-radius:50px;
  height:300px;
  overflow:hidden;

  ${Image} {
    object-fit: cover;
    margin:0 auto;
    width:100%;
    max-width: 100%;
    height:100%;
  }
`

const CardContent =styled.div`
  display:flex;
  flex-direction:column;
  justify-content: flex-start;
  padding:30px 40px 0 40px;
  min-height:150px;
`

const CardTitle =styled.h2 `
  color:#fff;
  font-size:32px;
  line-height:1.2;
  margin-top:0;
  margin-bottom:0;
`

const CardSubtitle = styled.p`
  font-size: 18px;
  line-height: 30px;
  color: #000;
  max-width: 500px;
  text-shadow: 1px 1px black;
  margin: 30px 0;
  font-weight: 600;
  margin-top:0;
  margin-bottom:30px;
`

const CardText = styled.div`
  color:#FFF;
  p {
    margin-top:0;
  }
`

const Cards = props => {
  const items = props.data.items
    ? props.data.items
    : [
        {
          bgColour: props.data.items.bgColour,
          image: props.data.items.image,
          imageLocal: props.data.items.image.source_url,
          title: props.data.items.title,
          subtitle: props.data.items.subtitle,
          link: props.data.items.link,
        }
      ]

      const responsive = {
        desktop: {
          breakpoint: { max: 6000, min: 1024 },
          items: 3,
          partialVisibilityGutter: 0 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
          breakpoint: { max: 1024, min: 768 },
          items: 2,
          partialVisibilityGutter: 0 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
          breakpoint: { max: 768, min: 0 },
          items: 1,
          partialVisibilityGutter: 0 // this is needed to tell the amount of px that should be visible.
        }
      }

  return (
    <Container className='customCards'>
      <Title>{props.data.title}</Title>
      <Carousel responsive={responsive} infinite={false} autoPlay={true} autoPlaySpeed={10000} arrows={false} showDots={true} 
      autoPlay={props.responsive !== "tablet" ? true : false}>

          {items.map((item, index) => (
            <CardsWrapper key={'item-' + index}>
              <Card style={{boxShadow: `20px 20px 0 ${item.bgColour}` || 'white' }}>
                <a href={item.link} title={item.title} >
                  <CardImgWrapper>
                    {item?.image?.imgixImageWp?.fluid && (
                        <Image
                          fluid={{ ...item.image.imgixImageWp.fluid, sizes: '100vw' }}
                        />
                    )}
                  </CardImgWrapper>
                  <CardContent>
                    {item.title && (<CardTitle>{item.title}</CardTitle>)}
                    {item.subtitle && (<CardSubtitle>{item.subtitle}</CardSubtitle>)}
                    {item.text && (<CardText dangerouslySetInnerHTML={{ __html: item.text }} />)}
                  </CardContent>
                </a>
              </Card>
            </CardsWrapper>
          ))}

      </Carousel>
    </Container>
  )
}

export default Cards
